:host {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    grid-area: header;
    padding: 0 40px;
    height: var(--layout-header-height);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2000;
    --zindex-base: 2000;
    background-color: var(--color-layout-base);
    box-sizing: border-box;
}

header {
    width: 100%;
    max-width: var(--layout-max-width);
    height: calc(var(--layout-header-base-height));
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr auto;
}

.left {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: flex-start;
    gap: 18px;
}

.center {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    gap: 18px;
}

.right {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: flex-end;
    gap: 18px;
}

.under {
    height: var(--layout-header-under-height);
    width: 100%;
    max-width: var(--layout-max-width);

    &::before {
        content: '';
        display: block;
        background-color: var(--color-layout-shade-10);
        position: absolute;
        height: var(--layout-header-under-height);
        left: 0;
        right: 0;
        bottom: 0;
    }
}

::slotted(es-nav[slot='under']) {
    height: 45px;
}

::slotted(es-nav[slot='left']),
::slotted(es-nav[slot='center']),
::slotted(es-nav[slot='right']) {
    height: 100%;
}

.backdrop {
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: var(--layout-header-under-height);
    left: 0px;
    z-index: -1;
    background-color: var(--color-layout-base);
    display: flex;
    justify-content: center;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -100;
        height: 4px;
        background-color: transparent;
    }
}

:host([dark]:not(.has_under):not(.has_banner):not([high-contrast])) {
    & .backdrop::after {
        background-color: var(--color-layout-shade-20);
    }
}

:host([dark][high-contrast]:not(.has_banner)) {
    & .backdrop::after {
        background-color: var(--color-layout-shade-70);
    }
}

::slotted([slot='backdrop']) {
    overflow: visible;
    max-width: 100%;
    width: var(--layout-max-width);
    margin: auto;
}
